export default "__VITE_ASSET__CxaiQMK5__"